import React from 'react';
import PropTypes from 'prop-types';

import {Button, Modal, Header, Form, Message} from 'semantic-ui-react';

const EditPolicyModal = ({open, nickname, onSave, onCancel, onFieldChange, loading, error}) => {
    let errorMessage;
    if (error) {
        const content = Array.isArray(error) ? error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : error;
        errorMessage = (<Message error header="Edit Policy Failed" content={content} />);
    }
    return (
        <Modal size="tiny" open={open} className="policy edit">
            <Header icon="edit" content="Edit Policy Nickname" />
            <Modal.Content>
                <Form loading={loading} error>
                    <Form.Field>
                        <input name="nickname" placeholder="Policy Nickname" onChange={onFieldChange} value={nickname} />
                    </Form.Field>
                    {errorMessage}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={onCancel} disabled={loading} />
                <Button primary content="Save" onClick={onSave} disabled={loading} />
            </Modal.Actions>
        </Modal>
    );
};

EditPolicyModal.propTypes = {
    open: PropTypes.bool.isRequired,
    nickname: PropTypes.string,
    onFieldChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default EditPolicyModal;